import SectionHeader from "../components/SectionHeader";
import { motion } from "framer-motion";
import TextWrapper from "./TextWrapper";
import {
    CAROUSEL_ITEM_HEADER_HEIGHT,
    CAROUSEL_ITEM_MEDIA_WIDTH,
    CAROUSEL_ITEM_PADDING,
    SectionLayoutProps
} from "./SectionLayout.constants";
import VariantWrapper from "./VariantWrapper";
import SectionMedia from "./SectionMedia";
import { GradualSpacing } from '../../../effects/GradualSpacing';
import { NIKE_EASE } from '../../../../rise/constants/nikerise';
import {
    LARGE_VARIANT_CONFIG,
    usePosterTitle,
} from "./usePosterTitle.hook";
import { DEFAULT_TRANSITION_DURATION } from '../ServiceMenuChapter.constants';

const CAROUSEL_VARIANT_3_SETTINGS = {
    mediaHeight: 81.98 // 1574
}

function SectionLayoutVariant3(props: SectionLayoutProps) {
    const {
        headerSettings,
        section,
        isEntrySection,
    } = props;
    const {
        media,
        title,
    } = section;

    const computedTitleSize = usePosterTitle(title, LARGE_VARIANT_CONFIG);

    return (
        <VariantWrapper section={section}>
            <SectionHeader {...headerSettings} />

            <motion.div
                style={{
                    position: 'absolute',
                    zIndex: 200,
                }}
                initial={isEntrySection ? {
                    width: '100vw',
                    height: '100vh',
                    x: 0,
                    y: 0,
                } : false}
                animate={{
                    width: `${CAROUSEL_ITEM_MEDIA_WIDTH}vh`,
                    height: `${CAROUSEL_VARIANT_3_SETTINGS.mediaHeight}vh`,
                    x: `${CAROUSEL_ITEM_PADDING}vh`,
                    y: `${CAROUSEL_ITEM_HEADER_HEIGHT}vh`,
                    transition: {
                        ease: NIKE_EASE,
                        duration: DEFAULT_TRANSITION_DURATION,
                    },
                }}
                exit={{
                    width: `${CAROUSEL_ITEM_MEDIA_WIDTH}vh`,
                    height: `${CAROUSEL_VARIANT_3_SETTINGS.mediaHeight}vh`,
                    x: `${CAROUSEL_ITEM_PADDING}vh`,
                    y: '-100vh',
                    transition: {
                        ease: 'easeIn',
                        duration: DEFAULT_TRANSITION_DURATION,
                    },
                }}
            >
                <SectionMedia media={media}/>
            </motion.div>

            <TextWrapper
                style={{
                    padding: `${CAROUSEL_ITEM_PADDING}vh`,
                    bottom: 0,
                    left: 0,
                    fontSize: `${computedTitleSize.fontSize}vh`,
                    lineHeight: `${computedTitleSize.lineHeight}vh`,
                    textTransform: 'uppercase',
                    fontFamily: 'HelveticaNowDisplay',
                    fontWeight: '500',
                }}
            >
                <GradualSpacing text={title} offset={1} />
            </TextWrapper>
        </VariantWrapper>
    )
}

export default SectionLayoutVariant3;
